import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Heading, Text } from '@grandvisionhq/elements';
import { Spinner, Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useWhatStepSlots } from '../../context/WhatStepSlotContext/WhatStepSlotContext.js';
import AppointmentTypeListContainer from '../AppointmentTypeList/AppointmentTypeListContainer.js';
import SelectedChoicesContainer from '../SelectedChoices/SelectedChoicesContainer.js';
import { ToolTipPopUpModalContainer } from '../ToolTipPopUpModal/ToolTipPopUpModalContainer.js';

const AppointmentTypes = (_param)=>{
    var { className , labels , appointmentDisplayType , appointmentTypes , groupedAppointmentTypes , onClick , onClickToolTip , onCloseToolTip , loading =false , activeToolTip =null , AgeGroupSelector  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "appointmentDisplayType",
        "appointmentTypes",
        "groupedAppointmentTypes",
        "onClick",
        "onClickToolTip",
        "onCloseToolTip",
        "loading",
        "activeToolTip",
        "AgeGroupSelector"
    ]);
    const { getLabel  } = useIntl();
    const { Slots  } = useWhatStepSlots();
    const bar = labels.description ? labels.description : null;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('appointment-types', className)
    }), /*#__PURE__*/ React.createElement(ToolTipPopUpModalContainer, {
        toolTip: activeToolTip,
        isOpen: Boolean(activeToolTip),
        onModalClose: onCloseToolTip,
        className: "appointment-types__tooltip"
    }), /*#__PURE__*/ React.createElement(SelectedChoicesContainer, null), /*#__PURE__*/ React.createElement(Heading, {
        className: "appointment-types__heading",
        component: "h2",
        variant: "small"
    }, labels.heading), labels.description && !!appointmentTypes.length && (Slots.Description ? /*#__PURE__*/ React.createElement(Slots.Description, {
        bar: bar
    }) : /*#__PURE__*/ React.createElement(Text, {
        className: "appointment-types__description",
        variant: "body"
    }, labels.description)), loading ? /*#__PURE__*/ React.createElement("div", {
        className: "appointment-types__loader"
    }, /*#__PURE__*/ React.createElement(Spinner, {
        "aria-label": getLabel('common.loadingText')
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, !!appointmentTypes.length ? /*#__PURE__*/ React.createElement(React.Fragment, null, AgeGroupSelector && /*#__PURE__*/ React.createElement(AgeGroupSelector, null), /*#__PURE__*/ React.createElement(AppointmentTypeListContainer, {
        className: "appointment-types__list",
        appointmentDisplayType: appointmentDisplayType,
        appointmentTypes: appointmentTypes,
        groupedAppointmentTypes: groupedAppointmentTypes,
        onClick: onClick,
        onClickToolTip: onClickToolTip
    })) : /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        className: "alert-m-default appointment-types__alert"
    }, labels.alert)));
};

export { AppointmentTypes as default };
//# sourceMappingURL=AppointmentTypes.js.map
